var exports = {
  "fT": "defaultColor__rSU1-n",
  "Aq": "noUnderline__-1njX1",
  "mi": "strikeThrough__pIWWgY",
};

module.exports = exports;
